const SearchType = {
    Basket: 'basket',
    UserSearch: 'user-search',
    Distribution: 'distribution',
    FullText: 'search',
    AdvancedSearch: 'adv-search',
    DocumentIDs: 'document-ids',
    Alert: 'alert',
};
export default SearchType;
